var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"title_wrap ft18 font-text"},[_c('i'),_c('span',{staticClass:"span1"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }